import { FC } from "react";
import { useUserSettings } from "../../../context/userSettingsContext";
import { useI18n } from "../../../hooks/useTranslations";
import SvgCarDirection from "../../icons/DirectionCar";
import SvgPerson from "../../icons/Person";
import Nav from "../Nav";

type MyAreaMenuProps = {
  closeSidebar: () => void;
};

const MyAreaMenu: FC<MyAreaMenuProps> = ({ closeSidebar }) => {
  const i18n = useI18n();
  const userSettings = useUserSettings();

  return (
    <Nav.Group title={i18n.t.common.myArea}>
      <Nav.Item text={i18n.t.common.myProfile} to="/me" icon={SvgPerson} onClick={closeSidebar} />
      <Nav.Item text={i18n.t.common.myCars} to="/my_cars" icon={SvgCarDirection} onClick={closeSidebar} />
      {!!userSettings.isManager && (
        <Nav.Item text={i18n.t.common.myTeamCars} to="/my_team_cars" icon={SvgCarDirection} onClick={closeSidebar} />
      )}
    </Nav.Group>
  );
};

export default MyAreaMenu;
